import React from 'react'

export default class CatchError extends React.PureComponent {
  static getDerivedStateFromError() {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true }
  }

  componentDidCatch() {
    if (window.location.host === 'data.zhiyitech.cn') {
      window.location.href = '/error'
    }
  }

  render() {
    return this.props.children
  }
}
